export const createMarkup = markup => {
  return { __html: markup }
}
